module.exports = __webpack_public_path__ + "textures/edge_billboard.png";